import React from 'react';
import thumbsup from '../../assets/images/thumbsup.svg';
import insightsIcon from '../../assets/images/Insights.svg';
import EyeIcon from '../../assets/images/EyeIcon.svg';
import Share from '../../assets/images/Share.svg';
import Save from '../../assets/images/Save.svg';
import { ThumbsUp, Eye, Forward, Bookmark, BarChart2 } from 'lucide-react';
import { useNavigate } from "react-router-dom";

const ReelCard = ({ title, likes, views, shares, saves, thumbnail, item, contentType, isStory = false }) => {

    const navigate = useNavigate();

  const handleNavigate = () => {
      navigate("/video-insights", { state: { item, contentType } });
  }


  return (
    <div className="flex flex-col bg-white rounded-xl overflow-hidden transition-transform cursor-pointer group">
      <div className="w-[194px] h-[305px] aspect-[9/16] rounded-xl overflow-hidden relative border border-gray-100 shadow-sm">
        <img 
          src={thumbnail} 
          alt={title} 
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      
      <div className="py-3 px-1">
        <h3 className="font-medium text-[16px] text-[#0F0F0F] leading-tight mb-1 pr-4 f-fam-name-roboto h-[40px] line-clamp-2">
          {title}
        </h3>
        
        <div className="flex items-center space-x-3 mb-3 text-[11px] font-medium text-gray-600">
          <div className="flex items-center space-x-1">
            <img src={thumbsup} alt="Like" />
                       <span className="f-fam-name-figtree text-[12px] text-[#605F5F] font-normal">{likes}</span>

          </div>
          <div className="flex items-center space-x-1">
            <img src={EyeIcon} alt="Eye" />
                       <span className="f-fam-name-figtree text-[12px] text-[#605F5F] font-normal">{views} views</span>

          </div>
          <div className="flex items-center space-x-1">
                     <img src={Share} alt="Share" />

                      <span className="f-fam-name-figtree text-[14px] text-[#605F5F] font-medium">{shares}</span>

          </div>
          {saves !== undefined && !isStory && (
            <div className="flex items-center space-x-1">
              <img src={Save} alt="Save" />
                            <span className="f-fam-name-figtree text-[14px] text-[#605F5F] font-medium">{saves}</span>

            </div>
          )}
        </div>
        
        {!isStory && (
          <button onClick={handleNavigate} className="flex items-center justify-center space-x-1.5 bg-brandPurple text-white text-[11px] font-semibold px-3 py-1.5 rounded hover:bg-purple-700 transition-colors w-fit">
         <img src={insightsIcon} alt="Insights" />
          <span className="f-fam-name-inter text-[12px] text-[#FFFFFF] font-semibold">Insights</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ReelCard;
